import { render, staticRenderFns } from "./CustomUploadImageFile.vue?vue&type=template&id=6461263d&scoped=true"
import script from "./CustomUploadImageFile.vue?vue&type=script&lang=js"
export * from "./CustomUploadImageFile.vue?vue&type=script&lang=js"
import style0 from "./CustomUploadImageFile.vue?vue&type=style&index=0&id=6461263d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6461263d",
  null
  
)

export default component.exports